import { useCallback } from "react";

import { useStructuredSearchRefresh } from "@/components/StructuredSearch/hooks/useStructuredSearchRefresh";
import { ENDPOINTS } from "@/api/application-api";

/**
 * Shared structured request-logs refresh steps used by the AG Grid table and
 * the review-logs drawer (conditional end time + new-requests badge).
 */
export const useStructuredRequestLogsRefresh = () => {
  const { clearNewDataBadge, advanceStructuredEndIfNeeded } = useStructuredSearchRefresh();

  const clearNewRequestsBadge = useCallback(() => {
    clearNewDataBadge([ENDPOINTS.new_requests], { count_requests: 0 });
  }, [clearNewDataBadge]);

  return { clearNewRequestsBadge, advanceStructuredEndIfNeeded };
};
